var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSkippedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "checkmark-circle"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1823",
    "data-name": "Rectangle 1823",
    width: 40,
    height: 40,
    fill: "#727171",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8532",
    "data-name": "Group 8532",
    transform: "translate(-5.467 -1.66)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_920",
    "data-name": "Path 920",
    d: "M42.392,66.092h-2.35L40.037,58.4H38.49l.006,7.692H36.148a2.158,2.158,0,0,0-.037,4.316v6.739a2.6,2.6,0,0,0,2.6,2.6h1.124a2.6,2.6,0,0,0,2.6-2.6V70.407a2.158,2.158,0,0,0-.037-4.316Zm-4.735,6.576h3.225v.845H37.657Zm3.225-1.1H37.657V70.409h3.225ZM39.832,78.2H38.708a1.052,1.052,0,0,1-1.05-1.051V74.618h3.225v2.529A1.052,1.052,0,0,1,39.832,78.2Zm2.56-9.334H36.148a.612.612,0,0,1,0-1.225h6.245a.612.612,0,0,1,0,1.225Z",
    transform: "translate(-18.312 -41.601)",
    fill: "#727171",
    stroke: "#727171",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_921",
    "data-name": "Path 921",
    d: "M41.2,26.649a2.161,2.161,0,0,0-2.159-2.159H36.7V20.321A5.628,5.628,0,0,0,31.075,14.7H21.726V10.623A5.621,5.621,0,1,0,16.1,16.245h14.97a4.079,4.079,0,0,1,4.074,4.076V24.49H32.8a2.158,2.158,0,0,0-.037,4.316v6.739a2.6,2.6,0,0,0,2.6,2.6h1.124a2.6,2.6,0,0,0,2.6-2.6V28.806A2.16,2.16,0,0,0,41.2,26.649ZM12.031,10.623a4.074,4.074,0,1,1,8.148,0V14.7H16.1A4.08,4.08,0,0,1,12.031,10.623ZM34.31,31.067h3.225v.845H34.31Zm3.225-1.1H34.31V28.808h3.225ZM36.485,36.6H35.36a1.052,1.052,0,0,1-1.05-1.051V33.016h3.225v2.529A1.052,1.052,0,0,1,36.485,36.6Zm2.56-9.334H32.8a.612.612,0,0,1,0-1.225h6.245a.612.612,0,0,1,0,1.225Z",
    transform: "translate(0 0)",
    fill: "#727171",
    stroke: "#727171",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkippedIcon);
export default __webpack_public_path__ + "static/media/SkippedIcon.22f02151907ede94cd47da7257c960c3.svg";
export { ForwardRef as ReactComponent };